export function downloadFromBlob(blob, fileName) {
  try {
    const link = document.createElement("a");
    link.href = blob;
    link.download = fileName;
    link.setAttribute("target", "_blank");
    link.click();
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}

export function urlInfo(name) {
  let result = "";
  if (name?.length) {
    result = name.toLowerCase().split(" ").join("-").toLocaleLowerCase();
  }
  return result;
}

export const handleLinkClick = (e, url, router) => {
  if (url) {
    const isAbsoluteUrl = /^(http|https):\/\//.test(url);
    if (isAbsoluteUrl) {
      e.preventDefault();
      window.location.href = url;
    } else {
      e.preventDefault();
      
      // Check if this is a country selection and update cookies accordingly
      handleCountrySelection(url);
      
      router.push(url);
    }
  }
};

// Helper function to handle country selection cookie updates
const handleCountrySelection = (url) => {
  // Only handle relative URLs
  if (!url || url.startsWith('http')) return;
  
  // Check for South Africa (Global) - root path or URLs that don't start with known countries
  if (url === '/' || url === '' || url === '#') {
    import('@/utils/cookieutils').then(({ setStayGlobal }) => {
      setStayGlobal();
    });
    return;
  }
  
  // Extract country from URL (e.g., '/nigeria' -> 'nigeria')
  const countryFromUrl = url.replace(/^\//, '').split('/')[0];
  
  // Dynamically import country constants and cookie utilities
  Promise.all([
    import('@/Config/countryConstants'),
    import('@/utils/cookieutils')
  ]).then(([{ KNOWN_COUNTRIES, GLOBAL_ONLY_PAGES }, { setStayGlobal, setSelectedCountryByUser }]) => {
    // Check if this is a known country
    if (KNOWN_COUNTRIES.includes(countryFromUrl)) {
      setSelectedCountryByUser(countryFromUrl);
    } else {
      // If URL doesn't start with a known country, it's likely South Africa (Global)
      // This handles cases like /events, /about-us, etc.
      // Only set stayGlobal if this is not a global-only page (to avoid conflicts)
      const isGlobalOnlyPage = GLOBAL_ONLY_PAGES.includes(countryFromUrl);
      if (!isGlobalOnlyPage) {
        setStayGlobal();
      }
    }
  }).catch(error => {
    console.error('Helper: Error importing constants or cookie utilities:', error);
  });
};

export const capitalizeText = (text) => {
  const cleanedText = text.replace(/[\/-]/g, " ").toLowerCase();

  return cleanedText
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
